// This function takes a CSV (Comma-Separated Values) string and a timeZone as input
export const formatCSV = (data, timeZone) => {
  // Split the input CSV string into an array of values using commas as the delimiter
  const formattedData = data.split(",").map((item) => {
    // Convert each item to a Date object
    const date = new Date(item);

    // Check if the date is valid and the item is not a number
    if (!isNaN(Number(date)) && isNaN(item)) {
      // Define options for formatting the date and time
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZoneName: "short",
      };

      // If timeZone is provided and it's not "Local", set timeZone in options (e.g., UTC, Asia/Kolkata)
      if (timeZone && timeZone !== "Local") {
        options.timeZone = timeZone;
      }

      // Format the date and time using the specified options
      // localDate contains data in this format: 12/29/2023, 14:46:21 GMT+5:30
      const localDate = date.toLocaleString("en-US", options);

      // Split the formatted date and time into datePart and timePart
      // datePart contains: 12/29/2023, and timePart contains: 14:46:21 GMT+5:30
      let [datePart, timePart] = localDate.split(", ");

      // Split the datePart into month, day, and year
      // month = 12, day = 29, year = 2023
      let [month, day, year] = datePart.split("/");

      // Return the formatted date and time in the "YYYY-MM-DD HH:mm:ss" format.
      // slice is used to remove the timeZone part from timePart
      return `${year}-${month}-${day} ${timePart.slice(0, 8)}`;
    } else {
      // If the item is not a valid date, return it as is
      return item;
    }
  });

  // Join the formattedData array into a CSV string and return it
  return formattedData.join();
};
